var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToolsMaintenanceRepairs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 4.39625C3.47495 4.52587 3.16209 4.55079 2.86999 4.46635C2.57789 4.3819 2.32658 4.19389 2.16313 3.9375L1.25 2.5L2.5 1.25L3.9375 2.16313C4.19389 2.32658 4.3819 2.57789 4.46635 2.86999C4.55079 3.16209 4.52587 3.47495 4.39625 3.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8946 16.5206L9.62398 12.25C9.54726 12.1723 9.48735 12.0797 9.448 11.9778C9.40864 11.876 9.39068 11.7672 9.39523 11.6581L9.41898 10.92L8.32961 10.9556L7.80273 10.4287L10.4277 7.80371L10.9546 8.33059L10.919 9.41996L11.6571 9.39621C11.7662 9.39166 11.875 9.40962 11.9769 9.44897C12.0787 9.48833 12.1713 9.54824 12.249 9.62496L16.5227 13.8987C16.8434 14.2193 16.8259 14.7562 16.4834 15.0987L15.0946 16.4812C14.7521 16.8237 14.2152 16.8412 13.8946 16.5206Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48242 3.48242L9.61305 8.61305",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61305 9.61305L3.48242 4.48242",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 11.25L14.75 14.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0007 6.56231C13.5022 6.75803 14.0501 6.80225 14.5765 6.68949C15.1029 6.57673 15.5846 6.31194 15.962 5.92797C16.3393 5.54399 16.5956 5.05771 16.6991 4.52942C16.8027 4.00112 16.7489 3.45406 16.5444 2.95606L15.0007 4.49981H14.2938L13.5007 3.70668V2.99981L15.0444 1.45606C14.5464 1.2516 13.9994 1.1978 13.4711 1.30135C12.9428 1.40489 12.4565 1.66121 12.0725 2.03853C11.6886 2.41586 11.4238 2.89758 11.311 3.42398C11.1982 3.95038 11.2425 4.4983 11.4382 4.99981",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99981 11.4372C4.4983 11.2415 3.95038 11.1973 3.42398 11.31C2.89758 11.4228 2.41586 11.6876 2.03853 12.0716C1.66121 12.4555 1.40489 12.9418 1.30135 13.4701C1.1978 13.9984 1.2516 14.5455 1.45606 15.0435L2.99981 13.4997H3.70668L4.49981 14.2928V14.9997L2.95606 16.5435C3.45406 16.7479 4.00112 16.8017 4.52942 16.6982C5.05771 16.5946 5.54399 16.3383 5.92797 15.961C6.31194 15.5837 6.57673 15.1019 6.68949 14.5755C6.80225 14.0491 6.75803 13.5012 6.56231 12.9997",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3344 4.66602L9.5 6.49977",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3344 6.66602L12.25 7.75039",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 11.3337L6.49977 9.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75039 12.25L6.66602 13.3344",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsMaintenanceRepairs);
export default __webpack_public_path__ + "static/media/tools-maintenance-repairs.0a42319d.svg";
export { ForwardRef as ReactComponent };